import { ErrorType } from 'data/App/types'

import { CurrenciesActions } from './actions'
import { FETCH_CURRENCIES, FETCH_ERROR_CURRENCIES, FETCH_SUCCESS_CURRENCIES } from './actionTypes'
import { ApiCurrency } from './types'

export type CurrenciesState = {
  currencies?: ApiCurrency[]
  error?: ErrorType
  fetching: boolean
}

const currenciesReducer = (
  state: CurrenciesState = { fetching: false },
  action: CurrenciesActions
): CurrenciesState => {
  switch (action.type) {
    case FETCH_CURRENCIES:
      return { ...state, fetching: true }
    case FETCH_SUCCESS_CURRENCIES:
      return { ...state, currencies: action.payload, fetching: false }
    case FETCH_ERROR_CURRENCIES:
      return { ...state, error: action.error, fetching: false }
    default:
      return state
  }
  return state
}

export default currenciesReducer
